import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import AuctioneerPage from './pages/AuctioneerPage';
import BidderPage from './pages/BidderPage';
import AuditPage from './pages/AuditPage';
import AdminPage from './pages/AdminPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { homePathForRole } from './roleHome';

function ProtectedRoute({ role, children }: { role: string; children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  if (user.role !== role) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={
        user ? <Navigate to={homePathForRole(user.role)} replace /> : <LoginPage />
      } />
      <Route path="/auctioneer" element={
        <ProtectedRoute role="AUCTIONEER"><AuctioneerPage /></ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute role="SUPERADMIN"><AdminPage /></ProtectedRoute>
      } />
      <Route path="/bidder" element={
        <ProtectedRoute role="BIDDER"><BidderPage /></ProtectedRoute>
      } />
      <Route path="/auctioneer/audit/:auctionId" element={
        <ProtectedRoute role="AUCTIONEER"><AuditPage /></ProtectedRoute>
      } />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
